import { ApolloError } from '@apollo/client';
import { logError } from '#utils';
import { useSnackbar } from 'notistack';
import { useCallback } from 'react';

const useGenericOnError = () => {
  const { enqueueSnackbar } = useSnackbar();

  const errorHandler = useCallback(
    ({ error, errorTitle = '' }: { error: ApolloError | string; errorTitle?: string }) => {
      if (!error) {
        return;
      }
      logError(error);
      if (error instanceof ApolloError) {
        enqueueSnackbar(`${errorTitle} ${error.cause?.message || error.message}`.trim(), {
          variant: 'error',
        });
      } else {
        enqueueSnackbar(error, {
          variant: 'error',
        });
      }
    },
    [enqueueSnackbar]
  );

  return errorHandler;
};

export default useGenericOnError;
